let insightsSimilarHomeComparisonApiBody = [
    {
        "intervalStart": 1483938000,
        "intervalEnd": 1486529999,
        "intervalStartDate": "Jan 9, 2017",
        "intervalEndDate": "Feb 7, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 59,
                "userCons": 542,
                "averageSHCCost": null,
                "averageSHCCons": null,
                "efficientSHCCost": null,
                "efficientSHCCons": null
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1486530000,
        "intervalEnd": 1489035599,
        "intervalStartDate": "Feb 8, 2017",
        "intervalEndDate": "Mar 8, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 55,
                "userCons": 523,
                "averageSHCCost": null,
                "averageSHCCons": null,
                "efficientSHCCost": null,
                "efficientSHCCons": null
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1489035600,
        "intervalEnd": 1491537599,
        "intervalStartDate": "Mar 9, 2017",
        "intervalEndDate": "Apr 6, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 43,
                "userCons": 423,
                "averageSHCCost": 40,
                "averageSHCCons": 388,
                "efficientSHCCost": 12,
                "efficientSHCCons": 113
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1491537600,
        "intervalEnd": 1494302399,
        "intervalStartDate": "Apr 7, 2017",
        "intervalEndDate": "May 8, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 42,
                "userCons": 430,
                "averageSHCCost": 207,
                "averageSHCCons": 2113,
                "efficientSHCCost": 65,
                "efficientSHCCons": 661
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1494302400,
        "intervalEnd": 1496894399,
        "intervalStartDate": "May 9, 2017",
        "intervalEndDate": "Jun 7, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 30,
                "userCons": 330,
                "averageSHCCost": 196,
                "averageSHCCons": 2131,
                "efficientSHCCost": 72,
                "efficientSHCCons": 782
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1496894400,
        "intervalEnd": 1499745599,
        "intervalStartDate": "Jun 8, 2017",
        "intervalEndDate": "Jul 10, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 52,
                "userCons": 562,
                "averageSHCCost": 231,
                "averageSHCCons": 2489,
                "efficientSHCCost": 78,
                "efficientSHCCons": 840
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1499745600,
        "intervalEnd": 1502251199,
        "intervalStartDate": "Jul 11, 2017",
        "intervalEndDate": "Aug 8, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 36,
                "userCons": 436,
                "averageSHCCost": 176,
                "averageSHCCons": 2117,
                "efficientSHCCost": 63,
                "efficientSHCCons": 760
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1502251200,
        "intervalEnd": 1505102399,
        "intervalStartDate": "Aug 9, 2017",
        "intervalEndDate": "Sep 10, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 38,
                "userCons": 476,
                "averageSHCCost": 162,
                "averageSHCCons": 2023,
                "efficientSHCCost": 71,
                "efficientSHCCons": 886
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1505102400,
        "intervalEnd": 1507607999,
        "intervalStartDate": "Sep 11, 2017",
        "intervalEndDate": "Oct 9, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 30,
                "userCons": 385,
                "averageSHCCost": 145,
                "averageSHCCons": 1847,
                "efficientSHCCost": 61,
                "efficientSHCCons": 784
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1507608000,
        "intervalEnd": 1510117199,
        "intervalStartDate": "Oct 10, 2017",
        "intervalEndDate": "Nov 7, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 29,
                "userCons": 374,
                "averageSHCCost": 157,
                "averageSHCCons": 2002,
                "efficientSHCCost": 67,
                "efficientSHCCons": 849
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1510117200,
        "intervalEnd": 1512709199,
        "intervalStartDate": "Nov 8, 2017",
        "intervalEndDate": "Dec 7, 2017",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 49,
                "userCons": 633,
                "averageSHCCost": 168,
                "averageSHCCons": 2156,
                "efficientSHCCost": 79,
                "efficientSHCCons": 1019
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1512709200,
        "intervalEnd": 1515560399,
        "intervalStartDate": "Dec 8, 2017",
        "intervalEndDate": "Jan 9, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 39,
                "userCons": 503,
                "averageSHCCost": 183,
                "averageSHCCons": 2351,
                "efficientSHCCost": 90,
                "efficientSHCCons": 1164
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1515560400,
        "intervalEnd": 1518065999,
        "intervalStartDate": "Jan 10, 2018",
        "intervalEndDate": "Feb 7, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 32,
                "userCons": 387,
                "averageSHCCost": 159,
                "averageSHCCons": 1942,
                "efficientSHCCost": 68,
                "efficientSHCCons": 828
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1518066000,
        "intervalEnd": 1520571599,
        "intervalStartDate": "Feb 8, 2018",
        "intervalEndDate": "Mar 8, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 31,
                "userCons": 404,
                "averageSHCCost": 135,
                "averageSHCCons": 1747,
                "efficientSHCCost": 57,
                "efficientSHCCons": 734
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1520571600,
        "intervalEnd": 1523419199,
        "intervalStartDate": "Mar 9, 2018",
        "intervalEndDate": "Apr 10, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 46,
                "userCons": 621,
                "averageSHCCost": 146,
                "averageSHCCons": 1982,
                "efficientSHCCost": 60,
                "efficientSHCCons": 815
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1523419200,
        "intervalEnd": 1525838399,
        "intervalStartDate": "Apr 11, 2018",
        "intervalEndDate": "May 8, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 26,
                "userCons": 337,
                "averageSHCCost": 133,
                "averageSHCCons": 1721,
                "efficientSHCCost": 52,
                "efficientSHCCons": 672
            },
            "8": {
                "appId": 8,
                "userCost": 7,
                "userCons": 96,
                "averageSHCCost": 27,
                "averageSHCCons": 374,
                "efficientSHCCost": 3,
                "efficientSHCCons": 41
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1525838400,
        "intervalEnd": 1528430399,
        "intervalStartDate": "May 9, 2018",
        "intervalEndDate": "Jun 7, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 29,
                "userCons": 367,
                "averageSHCCost": 151,
                "averageSHCCons": 1909,
                "efficientSHCCost": 58,
                "efficientSHCCons": 730
            },
            "8": {
                "appId": 8,
                "userCost": 9,
                "userCons": 119,
                "averageSHCCost": 106,
                "averageSHCCons": 1401,
                "efficientSHCCost": 23,
                "efficientSHCCons": 308
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1528430400,
        "intervalEnd": 1531195199,
        "intervalStartDate": "Jun 8, 2018",
        "intervalEndDate": "Jul 9, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 55,
                "userCons": 672,
                "averageSHCCost": 173,
                "averageSHCCons": 2105,
                "efficientSHCCost": 60,
                "efficientSHCCons": 732
            },
            "4": {
                "appId": 4,
                "userCost": 21,
                "userCons": 256,
                "averageSHCCost": 24,
                "averageSHCCons": 287,
                "efficientSHCCost": 17,
                "efficientSHCCons": 202
            },
            "8": {
                "appId": 8,
                "userCost": 12,
                "userCons": 140,
                "averageSHCCost": 128,
                "averageSHCCons": 1496,
                "efficientSHCCost": 83,
                "efficientSHCCons": 967
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1531195200,
        "intervalEnd": 1533873599,
        "intervalStartDate": "Jul 10, 2018",
        "intervalEndDate": "Aug 9, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 75,
                "userCons": 850,
                "averageSHCCost": 175,
                "averageSHCCons": 1997,
                "efficientSHCCost": 63,
                "efficientSHCCons": 722
            },
            "4": {
                "appId": 4,
                "userCost": 42,
                "userCons": 478,
                "averageSHCCost": 29,
                "averageSHCCons": 332,
                "efficientSHCCost": 23,
                "efficientSHCCons": 266
            },
            "8": {
                "appId": 8,
                "userCost": 16,
                "userCons": 178,
                "averageSHCCost": 130,
                "averageSHCCons": 1452,
                "efficientSHCCost": 100,
                "efficientSHCCons": 1114
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1533873600,
        "intervalEnd": 1536638399,
        "intervalStartDate": "Aug 10, 2018",
        "intervalEndDate": "Sep 10, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 56,
                "userCons": 661,
                "averageSHCCost": 165,
                "averageSHCCons": 1949,
                "efficientSHCCost": 62,
                "efficientSHCCons": 735
            },
            "4": {
                "appId": 4,
                "userCost": 21,
                "userCons": 250,
                "averageSHCCost": 18,
                "averageSHCCons": 212,
                "efficientSHCCost": 15,
                "efficientSHCCons": 179
            },
            "8": {
                "appId": 8,
                "userCost": 17,
                "userCons": 197,
                "averageSHCCost": 129,
                "averageSHCCons": 1489,
                "efficientSHCCost": 84,
                "efficientSHCCons": 975
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1536638400,
        "intervalEnd": 1539230399,
        "intervalStartDate": "Sep 11, 2018",
        "intervalEndDate": "Oct 10, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 32,
                "userCons": 412,
                "averageSHCCost": 148,
                "averageSHCCons": 1893,
                "efficientSHCCost": 62,
                "efficientSHCCons": 799
            },
            "4": {
                "appId": 4,
                "userCost": 4,
                "userCons": 47,
                "averageSHCCost": 7,
                "averageSHCCons": 78,
                "efficientSHCCost": 6,
                "efficientSHCCons": 67
            },
            "8": {
                "appId": 8,
                "userCost": 11,
                "userCons": 147,
                "averageSHCCost": 104,
                "averageSHCCons": 1395,
                "efficientSHCCost": 70,
                "efficientSHCCons": 932
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1539230400,
        "intervalEnd": 1541739599,
        "intervalStartDate": "Oct 11, 2018",
        "intervalEndDate": "Nov 8, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 54,
                "userCons": 684,
                "averageSHCCost": 157,
                "averageSHCCons": 1983,
                "efficientSHCCost": 78,
                "efficientSHCCons": 982
            },
            "3": {
                "appId": 3,
                "userCost": 15,
                "userCons": 191,
                "averageSHCCost": 31,
                "averageSHCCons": 396,
                "efficientSHCCost": 14,
                "efficientSHCCons": 181
            },
            "8": {
                "appId": 8,
                "userCost": 13,
                "userCons": 160,
                "averageSHCCost": 110,
                "averageSHCCons": 1351,
                "efficientSHCCost": 73,
                "efficientSHCCons": 903
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1541739600,
        "intervalEnd": 1544504399,
        "intervalStartDate": "Nov 9, 2018",
        "intervalEndDate": "Dec 10, 2018",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 116,
                "userCons": 1464,
                "averageSHCCost": 189,
                "averageSHCCons": 2396,
                "efficientSHCCost": 95,
                "efficientSHCCons": 1207
            },
            "3": {
                "appId": 3,
                "userCost": 73,
                "userCons": 917,
                "averageSHCCost": 53,
                "averageSHCCons": 671,
                "efficientSHCCost": 39,
                "efficientSHCCons": 484
            },
            "8": {
                "appId": 8,
                "userCost": 10,
                "userCons": 127,
                "averageSHCCost": 117,
                "averageSHCCons": 1491,
                "efficientSHCCost": 72,
                "efficientSHCCons": 912
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1544504400,
        "intervalEnd": 1547441999,
        "intervalStartDate": "Dec 11, 2018",
        "intervalEndDate": "Jan 13, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 124,
                "userCons": 1618,
                "averageSHCCost": 188,
                "averageSHCCons": 2455,
                "efficientSHCCost": 87,
                "efficientSHCCons": 1140
            },
            "3": {
                "appId": 3,
                "userCost": 81,
                "userCons": 1052,
                "averageSHCCost": 56,
                "averageSHCCons": 730,
                "efficientSHCCost": 51,
                "efficientSHCCons": 664
            },
            "8": {
                "appId": 8,
                "userCost": 10,
                "userCons": 133,
                "averageSHCCost": 119,
                "averageSHCCons": 1577,
                "efficientSHCCost": 56,
                "efficientSHCCons": 743
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1547442000,
        "intervalEnd": 1549861199,
        "intervalStartDate": "Jan 14, 2019",
        "intervalEndDate": "Feb 10, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 92,
                "userCons": 1162,
                "averageSHCCost": 141,
                "averageSHCCons": 1772,
                "efficientSHCCost": 60,
                "efficientSHCCons": 753
            },
            "3": {
                "appId": 3,
                "userCost": 57,
                "userCons": 715,
                "averageSHCCost": 38,
                "averageSHCCons": 480,
                "efficientSHCCost": 29,
                "efficientSHCCons": 363
            },
            "8": {
                "appId": 8,
                "userCost": 9,
                "userCons": 112,
                "averageSHCCost": 105,
                "averageSHCCons": 1302,
                "efficientSHCCost": 54,
                "efficientSHCCons": 678
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1549861200,
        "intervalEnd": 1552363199,
        "intervalStartDate": "Feb 11, 2019",
        "intervalEndDate": "Mar 11, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 109,
                "userCons": 1343,
                "averageSHCCost": 140,
                "averageSHCCons": 1729,
                "efficientSHCCost": 60,
                "efficientSHCCons": 743
            },
            "3": {
                "appId": 3,
                "userCost": 63,
                "userCons": 775,
                "averageSHCCost": 21,
                "averageSHCCons": 259,
                "efficientSHCCost": 14,
                "efficientSHCCons": 175
            },
            "8": {
                "appId": 8,
                "userCost": 9,
                "userCons": 115,
                "averageSHCCost": 105,
                "averageSHCCons": 1346,
                "efficientSHCCost": 69,
                "efficientSHCCons": 878
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1552363200,
        "intervalEnd": 1554868799,
        "intervalStartDate": "Mar 12, 2019",
        "intervalEndDate": "Apr 9, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 78,
                "userCons": 938,
                "averageSHCCost": 143,
                "averageSHCCons": 1717,
                "efficientSHCCost": 63,
                "efficientSHCCons": 753
            },
            "3": {
                "appId": 3,
                "userCost": 35,
                "userCons": 416,
                "averageSHCCost": 13,
                "averageSHCCons": 159,
                "efficientSHCCost": 10,
                "efficientSHCCons": 120
            },
            "8": {
                "appId": 8,
                "userCost": 12,
                "userCons": 149,
                "averageSHCCost": 108,
                "averageSHCCons": 1344,
                "efficientSHCCost": 70,
                "efficientSHCCons": 870
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1554868800,
        "intervalEnd": 1557460799,
        "intervalStartDate": "Apr 10, 2019",
        "intervalEndDate": "May 9, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 43,
                "userCons": 584,
                "averageSHCCost": 123,
                "averageSHCCons": 1665,
                "efficientSHCCost": 62,
                "efficientSHCCons": 837
            },
            "3": {
                "appId": 3,
                "userCost": 11,
                "userCons": 154,
                "averageSHCCost": 12,
                "averageSHCCons": 168,
                "efficientSHCCost": 7,
                "efficientSHCCons": 100
            },
            "8": {
                "appId": 8,
                "userCost": 7,
                "userCons": 98,
                "averageSHCCost": 99,
                "averageSHCCons": 1388,
                "efficientSHCCost": 64,
                "efficientSHCCons": 892
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1557460800,
        "intervalEnd": 1560139199,
        "intervalStartDate": "May 10, 2019",
        "intervalEndDate": "Jun 9, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 29,
                "userCons": 382,
                "averageSHCCost": 110,
                "averageSHCCons": 1454,
                "efficientSHCCost": 70,
                "efficientSHCCons": 929
            },
            "8": {
                "appId": 8,
                "userCost": 9,
                "userCons": 124,
                "averageSHCCost": 103,
                "averageSHCCons": 1420,
                "efficientSHCCost": 69,
                "efficientSHCCons": 945
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1560139200,
        "intervalEnd": 1562731199,
        "intervalStartDate": "Jun 10, 2019",
        "intervalEndDate": "Jul 9, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 43,
                "userCons": 516,
                "averageSHCCost": 121,
                "averageSHCCons": 1438,
                "efficientSHCCost": 75,
                "efficientSHCCons": 899
            },
            "8": {
                "appId": 8,
                "userCost": 11,
                "userCons": 129,
                "averageSHCCost": 115,
                "averageSHCCons": 1348,
                "efficientSHCCost": 85,
                "efficientSHCCons": 991
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1562731200,
        "intervalEnd": 1565323199,
        "intervalStartDate": "Jul 10, 2019",
        "intervalEndDate": "Aug 8, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 61,
                "userCons": 713,
                "averageSHCCost": 122,
                "averageSHCCons": 1434,
                "efficientSHCCost": 76,
                "efficientSHCCons": 889
            },
            "8": {
                "appId": 8,
                "userCost": 14,
                "userCons": 160,
                "averageSHCCost": 86,
                "averageSHCCons": 985,
                "efficientSHCCost": 75,
                "efficientSHCCons": 857
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1565323200,
        "intervalEnd": 1568001599,
        "intervalStartDate": "Aug 9, 2019",
        "intervalEndDate": "Sep 8, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 31,
                "userCons": 381,
                "averageSHCCost": 108,
                "averageSHCCons": 1320,
                "efficientSHCCost": 76,
                "efficientSHCCons": 923
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1568001600,
        "intervalEnd": 1570593599,
        "intervalStartDate": "Sep 9, 2019",
        "intervalEndDate": "Oct 8, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 42,
                "userCons": 538,
                "averageSHCCost": 74,
                "averageSHCCons": 953,
                "efficientSHCCost": 70,
                "efficientSHCCons": 900
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1570593600,
        "intervalEnd": 1573448399,
        "intervalStartDate": "Oct 9, 2019",
        "intervalEndDate": "Nov 10, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 84,
                "userCons": 909,
                "averageSHCCost": 109,
                "averageSHCCons": 1177,
                "efficientSHCCost": 93,
                "efficientSHCCons": 998
            }
        },
        "isMissingDataInterval": false
    },
    {
        "intervalStart": 1573448400,
        "intervalEnd": 1575867599,
        "intervalStartDate": "Nov 11, 2019",
        "intervalEndDate": "Dec 8, 2019",
        "applianceInfo": {
            "0": {
                "appId": 0,
                "userCost": 91,
                "userCons": 690,
                "averageSHCCost": 147,
                "averageSHCCons": 1117,
                "efficientSHCCost": 112,
                "efficientSHCCons": 852
            }
        },
        "isMissingDataInterval": false
    }
];

export default insightsSimilarHomeComparisonApiBody;